export type ValueKind = 'text' | 'money' | 'count' | 'percent';

export function valueText(value: string | number | null | undefined, kind: ValueKind): string {
  if (kind === 'text') {
    return value === null || value === undefined || value === '' ? '—' : String(value);
  }
  if (value === null || value === undefined || typeof value !== 'number' || !Number.isFinite(value)) {
    return 'Unknown';
  }
  if (kind === 'percent') {
    return new Intl.NumberFormat('en-AU', {
      style: 'percent',
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(value);
  }
  return new Intl.NumberFormat('en-AU', {
    style: kind === 'money' ? 'currency' : 'decimal',
    currency: 'AUD',
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0,
  }).format(value);
}

export function compactText(value: number | null | undefined, kind: ValueKind): string {
  if (value === null || value === undefined || !Number.isFinite(value)) {
    return 'Unknown';
  }
  if (kind === 'money' && Math.abs(value) >= 1000) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      currencyDisplay: 'narrowSymbol',
      notation: 'compact',
      maximumFractionDigits: 2,
    }).format(value);
  }
  return valueText(value, kind);
}

export function changeText(value: number | null): string {
  if (value === null || !Number.isFinite(value)) {
    return '';
  }
  const arrow = value > 0 ? '▲ +' : value < 0 ? '▼ ' : '► ';
  return `${arrow}${new Intl.NumberFormat('en-AU', { style: 'percent', maximumFractionDigits: 1 }).format(value)}`;
}
